import { render, staticRenderFns } from "./TrainingLog.vue?vue&type=template&id=422dca06&scoped=true&"
import script from "./TrainingLog.vue?vue&type=script&lang=js&"
export * from "./TrainingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dca06",
  null
  
)

export default component.exports